"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _locizeLauncher = require("@influitive/locize-launcher");

var options = {
  defaultNs: 'ProfileCard',
  ns: 'ProfileCard'
};
var i18n = (0, _locizeLauncher.i18nLocizeInstance)(process.env.LOCIZE_PROJECT_ID, process.env.LOCIZE_API_KEY, options);
var _default = i18n;
exports.default = _default;